import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@pella/sash-framework';
import { CTA } from '../../../';

const StandardMenu = ({ data }) => {
	if (!data?.standard?.[0]) return null;

	return (
		<div className={`standardMenu invisible absolute -left-16 w-64 overflow-hidden rounded border border-gray-10 bg-white opacity-0 shadow-[0_4px_8px_rgba(37,55,126,0.2)] transition-opacity group-focus-within:visible group-focus-within:opacity-100 group-hover:visible group-hover:opacity-100`}>
			<div className='px-10 py-6'>
				{data.standard[0].heading && <p className='standardMenu-heading mb-5 border-b border-b-gray-10 pb-3 text-2xl font-semibold !leading-snug'>{data.standard[0].heading}</p>}

				{data.standard[0].cta?.[0] && (
					<List
						bullets='none'
						className='space-y-3'
					>
						{data.standard[0].cta.map((cta, index) => (
							<li key={index}>
								<CTA
									data={cta}
									className='flex rounded-sm font-semibold no-underline transition-colors hover:bg-[rgba(0,130,62,0.1)] focus:bg-[rgba(0,130,62,0.1)] active:bg-primary active:text-white'
								/>
							</li>
						))}
					</List>
				)}

				{data.cta?.[0] && (
					<div className='mt-4 border-t border-t-gray-10 pt-4'>
						<CTA
							data={data.cta[0]}
							size='sm'
							className='flex items-center justify-center [&>span]:mr-2 [&>span]:!text-base'
							wide
						/>
					</div>
				)}
			</div>
		</div>
	);
};

StandardMenu.propTypes = {
	data: PropTypes.object,
};

export default StandardMenu;
